// removed by extract-text-webpack-plugin
module.exports = {"log-pane":"log-pane__log-pane","error-pane":"log-pane__error-pane","warning-pane":"log-pane__warning-pane","close":"log-pane__close"};


//////////////////
// WEBPACK FOOTER
// ./src/components/log-pane/log-pane.scss
// module id = 1229
// module chunks = 0